query LocationsChartData {
  kpiBusinessUnits {
    nodes {
      title
      amount
      linkSearchValue
    }
  }
}
